import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserSubscriber } from '@app/shared/subscribers/user.subscriber';
import { UserService } from '@shared/services/user.service';
import { IUser, User } from '../models/user';

@Injectable({
  providedIn: 'root',
})
export class SecurityAccessGuardService implements CanActivate {
  constructor(
    private _route: Router,
    private _userService: UserService,
    private _userSubscriber: UserSubscriber,
  ) {}

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {

      if (this._userSubscriber.getUser()) {
        return resolve(true);
      }

      this._userService.getUser().subscribe({
        next: (result: IUser) => {
          const user = new User(result);

          if (!user) {
            this._route.navigate(['unauthorised']);
            resolve(false);
            return;
          }

          if (!user.departments || user.departments.length === 0) {
            this._route.navigate(['unauthorised']);
            resolve(false);
            return;
          }

          this._userSubscriber.handleUserDepartment(user);
          resolve(true);
        },
        error: (error: Error) => {
          console.error('SecurityAccessGuardService - Error retrieving user:', error);
          this._route.navigate(['unauthorised']);
          resolve(false);
        },
      });
    });
  }
}
